import { useExperimentGroup } from 'services/Firebase/hooks/useExperimentGroup';
import { ActiveGroup, Experiment } from 'services/Firebase/utils/experiments';

import ConfirmationModalWithDiscountA from './ConfirmationModalWithDiscountA';
import ConfirmationModalWithDiscountControl from './ConfirmationModalWithDiscountControl';

const ConfirmationModalWithDiscount = () => {
    const variant = useExperimentGroup(Experiment.CancelPostOfferAcceptanceABTest);

    switch (variant) {
        case ActiveGroup.A:
            return <ConfirmationModalWithDiscountA />;

        case ActiveGroup.Control:
            return <ConfirmationModalWithDiscountControl />;

        default:
            return <ConfirmationModalWithDiscountControl />;
    }
};

export default ConfirmationModalWithDiscount;
